(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-glow-listicle"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.cgReady) return;
    root.dataset.cgReady = '1';

    /* ---- carousels ---- */
    root.querySelectorAll('[data-cg-carousel]').forEach(function (car) {
      var slides = Array.prototype.slice.call(car.querySelectorAll('[data-cg-slide]'));
      if (!slides.length) return;
      var dots = car.querySelector('[data-cg-dots]');
      var i = 0, timer;
      slides.forEach(function (_, n) {
        if (!dots) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Slide ' + (n + 1));
        b.innerHTML = '<i></i>';
        b.addEventListener('click', function () { go(n); restart(); });
        dots.appendChild(b);
      });
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        if (dots) Array.prototype.forEach.call(dots.children, function (d, k) {
          d.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
      }
      function restart() {
        clearInterval(timer);
        if (car.dataset.cgAuto === 'off') return;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = setInterval(function () { go(i + 1); }, 5000);
      }
      var prev = car.querySelector('[data-cg-prev]'), next = car.querySelector('[data-cg-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(i + 1); restart(); });
      go(0); restart();
    });

    /* ---- ingredient tabs ---- */
    root.querySelectorAll('[data-cg-tabs]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('[data-cg-tab]');
      var panels = wrap.querySelectorAll('[data-cg-panel]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          t.setAttribute('aria-selected', 'true');
          var p = wrap.querySelector('[data-cg-panel="' + t.dataset.cgTab + '"]');
          if (p) p.classList.add('is-active');
        });
      });
    });

    /* ---- timeline stages ---- */
    root.querySelectorAll('[data-cg-timeline]').forEach(function (wrap) {
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-cg-stage-tab]'));
      var panels = wrap.querySelectorAll('[data-cg-stage-panel]');
      function select(n) {
        tabs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === n);
          t.classList.toggle('is-done', k < n);
          t.setAttribute('aria-selected', k === n ? 'true' : 'false');
        });
        panels.forEach(function (p, k) { p.classList.toggle('is-active', k === n); });
      }
      tabs.forEach(function (t, k) { t.addEventListener('click', function () { select(k); }); });
      select(0);
    });

    /* ---- accordions ---- */
    root.querySelectorAll('[data-cg-accordion]').forEach(function (wrap) {
      var triggers = wrap.querySelectorAll('[data-cg-acc-trigger]');
      triggers.forEach(function (t) {
        t.addEventListener('click', function () {
          var open = t.getAttribute('aria-expanded') === 'true';
          triggers.forEach(function (x) {
            x.setAttribute('aria-expanded', 'false');
            var s = x.querySelector('[data-cg-acc-sign]');
            if (s) s.textContent = '+';
            var pn = x.parentElement.querySelector('[data-cg-acc-panel]');
            if (pn) pn.hidden = true;
          });
          if (!open) {
            t.setAttribute('aria-expanded', 'true');
            var s2 = t.querySelector('[data-cg-acc-sign]');
            if (s2) s2.textContent = '−';
            var p2 = t.parentElement.querySelector('[data-cg-acc-panel]');
            if (p2) p2.hidden = false;
          }
        });
      });
    });

    /* ---- buy box: quantity, variant, selling plan ---- */
    var box = root.querySelector('[data-cg-buybox]');
    if (box) {
      var moneyFormat = box.dataset.moneyFormat || '';
      function money(cents) {
        var v = (cents / 100).toFixed(2);
        var parts = v.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        var amount = parts.join('.');
        if (!moneyFormat) return '$' + amount;
        return moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/g, amount)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, v.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0]);
      }

      var variantInputs = box.querySelectorAll('[data-cg-variant]');
      var planInputs = box.querySelectorAll('[data-cg-plan]');
      var idField = box.querySelector('[data-cg-id-field]');
      var planField = box.querySelector('[data-cg-plan-field]');
      var submitLabel = box.querySelector('[data-cg-submit-label]');
      var savingsEl = box.querySelector('[data-cg-savings]');
      var subCard = box.querySelector('[data-cg-sub-card]');
      var stickyName = root.querySelector('[data-cg-sticky-name]');
      var stickyPrice = root.querySelector('[data-cg-sticky-price]');
      var stickySave = root.querySelector('[data-cg-sticky-save]');
      var ctaText = box.dataset.ctaLabel || 'Start the System';

      /* quantity stepper */
      var qtyInput = box.querySelector('[data-cg-qty-input]');
      var qtyMinus = box.querySelector('[data-cg-qty-minus]');
      var qtyPlus = box.querySelector('[data-cg-qty-plus]');
      function stepQty(delta) {
        if (!qtyInput) return;
        var min = parseInt(qtyInput.min, 10) || 1;
        var max = parseInt(qtyInput.max, 10) || 99;
        var next = (parseInt(qtyInput.value, 10) || min) + delta;
        qtyInput.value = Math.min(max, Math.max(min, next));
      }
      if (qtyMinus) qtyMinus.addEventListener('click', function () { stepQty(-1); });
      if (qtyPlus) qtyPlus.addEventListener('click', function () { stepQty(1); });

      function currentVariant() {
        var v = box.querySelector('[data-cg-variant]:checked');
        return v || variantInputs[0];
      }
      function currentPlanInput() {
        var p = box.querySelector('[data-cg-plan]:checked');
        return p || planInputs[0];
      }

      function sync() {
        var v = currentVariant();
        if (!v) return;
        var hasPlans = v.dataset.hasPlans === 'true';
        if (subCard) subCard.hidden = !hasPlans;
        if (!hasPlans) {
          var oneTime = box.querySelector('[data-cg-plan][value=""]');
          if (oneTime) oneTime.checked = true;
        }
        var plan = currentPlanInput();
        var planId = plan ? plan.value : '';
        var price = plan && plan.dataset.price ? parseInt(plan.dataset.price, 10) : parseInt(v.dataset.price, 10);
        var compare = parseInt(v.dataset.compare || v.dataset.price, 10);

        if (idField) idField.value = v.value;
        if (planField) planField.value = planId;
        if (submitLabel) submitLabel.textContent = ctaText + ' · ' + money(price);
        if (savingsEl) {
          savingsEl.hidden = compare <= price;
          savingsEl.textContent = (savingsEl.dataset.prefix || 'You are saving') + ' ' + money(compare - price);
        }
        box.querySelectorAll('[data-cg-plan-price]').forEach(function (el) {
          var pid = el.dataset.cgPlanPrice;
          var src = pid ? box.querySelector('[data-cg-plan][value="' + pid + '"]') : null;
          var cents = src && src.dataset.price ? parseInt(src.dataset.price, 10) : parseInt(v.dataset.price, 10);
          el.textContent = money(cents);
        });

        if (stickyName) stickyName.textContent = (v.dataset.title || '') + (planId ? ' · ' + (box.dataset.subLabel || 'Subscribe and Save') : '');
        if (stickyPrice) stickyPrice.textContent = money(price);
        if (stickySave) stickySave.textContent = compare > price ? '· Save ' + money(compare - price) : '';
      }

      variantInputs.forEach(function (el) {
        el.addEventListener('change', function () {
          var plans = el.dataset.hasPlans === 'true';
          var target = box.querySelector(plans ? '[data-cg-plan][data-default="true"]' : '[data-cg-plan][value=""]');
          if (target) target.checked = true;
          sync();
        });
      });
      planInputs.forEach(function (el) { el.addEventListener('change', sync); });
      sync();
    }
  }

  function boot() { document.querySelectorAll('[data-cglow]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-cglow]');
    if (r) { delete r.dataset.cgReady; init(r); }
  });
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            console.log(text);
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
              let sameCard = document.querySelector('.from-recommended');
                if(!sameCard) return;
              let cardHeight = parseInt(sameCard.clientHeight);
              let topValue = cardHeight / 2 + 5;
              let cardTopCSS = "calc(50% - "+topValue+'px)';
              let swiperContainer = document.querySelector('.product-recommendations .swiper');
              if(!swiperContainer) return;
              let swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
              let swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
              swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
              swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
